import { firmSizeLabels, industryLabels } from "@components/entity/constants";
import {
    EntityProfileIndustry,
    EntityProfileRevenueBracket,
    EntityProfileType,
    FirmSize,
} from "@common/types/entity";
import { entityTypeV2Labels } from "@common/constants/entity";
import { DropdownOption } from "@components/spreadsheet/cells/dropdownOption";

export const EXIT_ANIMATION_DURATION = 500;
export const PRODUCT_PREVIEW_URL = "/images/preview.png";
export const FRESHBOOKS_SIDEBAR_URL = "/images/freshbooks-sidebar.png";
export const ORGANIZATION_PREVIEW_URL = "/images/organization-preview.png";
export const TESTIMONIAL_AVATAR_URL = "/images/testimonial-avatar.png";
export const DEFAULT_COUNTRY_CODE = "US";

const industries = Object.values(EntityProfileIndustry);
export const entityTypes = Object.values(EntityProfileType).filter(
    // NOTE: delete after migration
    (type) => type !== EntityProfileType.NO_LEGAL_ENTITY,
);

export const isEntityProfileType = (
    value: string,
): value is EntityProfileType => entityTypes.some((type) => type === value);

export const annualRevenueBrackets = Object.values(EntityProfileRevenueBracket);

export const entityTypeOptions: DropdownOption[] = entityTypes.map((value) => ({
    value,
    label: entityTypeV2Labels[value],
}));

export const entityTypeItems = entityTypes.map((value) => ({
    value,
    label: entityTypeV2Labels[value],
}));

const industryOptions: DropdownOption[] = industries.map((value) => ({
    value,
    label: industryLabels[value],
}));

export const industryItems = industryOptions.map(
    (option) => option.value as EntityProfileIndustry,
);

const industryLabelByValue = new Map(
    industryOptions.map((option) => [
        option.value as EntityProfileIndustry,
        String(option.label ?? option.value),
    ]),
);

export const getIndustryLabel = (value: EntityProfileIndustry): string =>
    industryLabelByValue.get(value) ?? String(value);

export const industryPickerItems = industryItems.map((industry) => ({
    value: industry,
    label: getIndustryLabel(industry),
}));

const firmSizes = Object.values(FirmSize);
export const sizeOptions: DropdownOption[] = firmSizes.map((value) => ({
    value,
    label: firmSizeLabels[value],
}));
